<template>
  <section v-if="visible" id="essential-apps" class="section-block scroll-target city-apps-section">
    <h2 class="section-title tight">
      <span class="material-symbols-outlined city-apps-title-ico">phone_android</span>
      Apps essenciais
    </h2>
    <ul class="city-apps-list">
      <li v-for="(app, i) in rows" :key="`app-${i}`" class="city-apps-row ep-anchor">
        <div class="city-apps-text">
          <div class="city-apps-name">{{ app.name }}</div>
          <p class="city-apps-desc">{{ app.description || "—" }}</p>
        </div>
        <div class="city-apps-actions">
          <a
            v-if="hrefFor(app)"
            class="city-apps-dl"
            :href="hrefFor(app)"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="material-symbols-outlined city-apps-dl-ico" aria-hidden="true">download</span>
            Baixar app
          </a>
          <span v-else-if="!editMode" class="city-apps-no-link muted">Sem link</span>
          <button v-if="editMode" type="button" class="ep-btn" @click="$emit('edit', i)">editar</button>
        </div>
      </li>
    </ul>
    <button v-if="editMode" type="button" class="btn-ghost btn-small" @click="$emit('add')">+ adicionar item</button>
    <p v-if="editMode && !rows.length" class="hint-muted">Adicione pelo menos um app com nome para exibir aos visitantes.</p>
  </section>
</template>

<script>
import { toExternalHref } from "../utils/externalUrl";

export default {
  name: "CityEssentialAppsSection",
  props: {
    apps: { type: Array, default: () => [] },
    editMode: { type: Boolean, default: false },
  },
  emits: ["edit", "add"],
  computed: {
    rows() {
      const list = Array.isArray(this.apps) ? this.apps : [];
      if (this.editMode) return list.map((a) => ({
        name: (a?.name || "").trim(),
        description: (a?.description || "").trim(),
        link: (a?.link || "").trim(),
      }));
      return list
        .map((a) => ({
          name: (a?.name || "").trim(),
          description: (a?.description || "").trim(),
          link: (a?.link || "").trim(),
        }))
        .filter((a) => a.name);
    },
    visible() {
      if (this.editMode) return true;
      return this.rows.length >= 1;
    },
  },
  methods: {
    hrefFor(app) {
      return toExternalHref(app.link);
    },
  },
};
</script>

<style scoped>
.city-apps-section .section-title.tight {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.city-apps-title-ico {
  font-size: 28px !important;
  color: var(--primary, #004ac6);
}
.city-apps-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.city-apps-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 4px 16px 0;
  border-radius: 16px;
  transition: background 0.15s;
  position: relative;
}
.city-apps-row:hover {
  background: var(--surface-lowest, #fff);
}
.city-apps-text {
  flex: 1 1 200px;
  min-width: 0;
}
.city-apps-name {
  font-weight: 800;
  font-size: 1rem;
  letter-spacing: -0.02em;
  color: var(--on-surface, #191c1e);
}
.city-apps-desc {
  margin: 6px 0 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--on-variant, #434655);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.city-apps-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: center;
}
.city-apps-dl {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 9px 16px;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-decoration: none;
  white-space: nowrap;
  color: var(--primary, #004ac6);
  background: rgba(0, 74, 198, 0.07);
  border: 1px solid rgba(0, 74, 198, 0.22);
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  box-shadow: none;
}
.city-apps-dl:hover {
  background: rgba(0, 74, 198, 0.12);
  border-color: rgba(0, 74, 198, 0.38);
  box-shadow: 0 1px 3px rgba(0, 74, 198, 0.12);
}
.city-apps-dl:focus-visible {
  outline: 2px solid var(--primary, #004ac6);
  outline-offset: 2px;
}
.city-apps-dl-ico {
  font-size: 18px !important;
  font-variation-settings: "FILL" 0, "wght" 500, "GRAD" 0, "opsz" 24;
}
.city-apps-no-link {
  font-size: 0.75rem;
}
.hint-muted {
  margin-top: 12px;
  font-size: 0.8125rem;
  color: var(--outline, #737686);
}
.muted {
  color: var(--outline, #737686);
}
</style>
